
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";

interface ChatInputProps {
  input: string;
  isLoading: boolean;
  remainingMessages?: number;
  hasSubscription?: boolean;
  onInputChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const ChatInput = ({ 
  input, 
  isLoading, 
  remainingMessages = Infinity, 
  hasSubscription = false,
  onInputChange, 
  onSubmit 
}: ChatInputProps) => {
  const isDisabled = isLoading || (remainingMessages <= 0 && !hasSubscription);
  
  return (
    <form 
      onSubmit={onSubmit} 
      className="fixed bottom-0 left-0 right-0 p-3 md:p-4 border-t border-gray-700 bg-muted backdrop-blur-lg"
    >
      {!hasSubscription && remainingMessages < Infinity && (
        <div className="flex justify-center mb-2">
          <span className={`text-xs font-medium ${remainingMessages <= 1 ? 'text-destructive' : 'text-muted-foreground'}`}>
            {remainingMessages > 0 
              ? `${remainingMessages} free ${remainingMessages === 1 ? 'message' : 'messages'} remaining` 
              : 'Free limit reached. Subscribe for unlimited access.'}
          </span>
        </div>
      )}
      
      <div className="flex gap-2 max-w-full mx-auto">
        <Input
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          placeholder="Ask a question about the video..."
          className="bg-gray-700/80 text-sm md:text-base flex-1 h-10 md:h-12 rounded-full placeholder:text-gray-400"
          disabled={isDisabled}
        />
        <Button 
          type="submit" 
          size="icon"
          className="bg-primary hover:bg-primary/90 rounded-full w-10 h-10 md:w-12 md:h-12 shrink-0"
          disabled={isDisabled || !input.trim()}
        >
          <Send size={18} />
        </Button>
      </div>
    </form>
  );
};
